import React from "react";

const InputBox = ({ handleChange, fieldLabel, name, value, type }) => {
  const change = e => {
    handleChange(e);
  };
  return (
    <div className="field">
      <label className="field_label">{fieldLabel}</label>
      <input
        className="field_text"
        type={type}
        name={name}
        value={value}
        onChange={e => change(e)}
      />
    </div>
  );
};

export default InputBox;